module.exports = __webpack_public_path__ + "img/informal-leader-manipulator-3.bf81bcc8.svg";